import { render, staticRenderFns } from "./LawTradeFairCenterForm.vue?vue&type=template&id=3be9ece8&"
import script from "./LawTradeFairCenterForm.vue?vue&type=script&lang=js&"
export * from "./LawTradeFairCenterForm.vue?vue&type=script&lang=js&"
import style0 from "./LawTradeFairCenterForm.vue?vue&type=style&index=0&id=3be9ece8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports